export const environment = {
  production: false,
  apiUrl: 'https://api-dev.hrci.org/api',
  auth0: {
    domain: 'devlogin.hrci.org',
    clientId: 'wA2Y0UNfWCsNcdP9uIQmHh8dGZWcB6Xv'
  }
};
